import type {IViewColumn} from "../../../../data/models/ViewUtils";

/** Keep row props stable while still checking fresh headers on every table render. */
export function stabilizeTableHeaders(previous: Partial<IViewColumn>[], next: Partial<IViewColumn>[]): Partial<IViewColumn>[] {
	if (
		previous.length === next.length &&
		next.every((header, index) => {
			const keys = Object.keys(header) as (keyof IViewColumn)[];
			const oldHeader = previous[index];
			return (
				keys.length === Object.keys(oldHeader).length && keys.every((key) => Object.hasOwn(oldHeader, key) && Object.is(header[key], oldHeader[key]))
			);
		})
	) {
		return previous;
	}
	// Snapshot each column: callers may mutate a width or title on an existing object.
	return next.map((header) => ({...header}));
}
